import { Observable } from 'rxjs';

export class MutationObserverHelper {
  public static observeElementPresence(selector: string, container: HTMLElement = document.body): Observable<boolean> {
    return new Observable((observer) => {
      let isVisible = !!container.querySelector(selector);

      const mo = new MutationObserver(() => {
        const exists = !!container.querySelector(selector);

        if (exists && !isVisible) {
          isVisible = true;
          observer.next(true);
        } else if (!exists && isVisible) {
          isVisible = false;
          observer.next(false);
        }
      });

      mo.observe(container, {
        childList: true,
        subtree: true,
      });

      observer.next(isVisible);

      return () => {
        return mo.disconnect();
      };
    });
  }
}
